let Table =  {
    interfaceType:[
        {codeName:'核保接口', codeValue:'proposalOrder'},
        {codeName:'承保接口', codeValue:'policyOrder'},
        {codeName:'退保试算', codeValue:'refundCal'},
        {codeName:'退保/失效接口', codeValue:'refundOrder'},
        {codeName:'续费接口', codeValue:'renewOrder'},
        {codeName:'长险锁单申请', codeValue:'renewLock'},
        {codeName:'长险扣费结果同步', codeValue:'renewPay'},
        {codeName:'赠险出单', codeValue:'policyFree'},
        {codeName:'数据同步', codeValue:'dataTransfer'},
        {codeName:'保单升级接口', codeValue:'upgradeOrder'},
        {codeName:'订单状态通知', codeValue:'statusNotice'},
        {codeName:'回执确认', codeValue:'orderReceipt'},
        {codeName:'电子保单查询', codeValue:'queryPolicy'},
        {codeName:'预核保接口', codeValue:'preProposal'},
        {codeName:'出单同步接口', codeValue:'orderTransfer'},
        {codeName:'订单查询接口', codeValue:'queryOrder'},
        {codeName:'批改接口', codeValue:'modifyOrder'},
        {codeName:'回访接口', codeValue:'returnVisit'},
        {codeName:'回访通知接口', codeValue:'visitNotice'},
        {codeName:'申请福利接口', codeValue:'welfareOrder'},
        {codeName:'福利状态通知', codeValue:'welfareNotice'},
        {codeName:'取消福利接口', codeValue:'cancelWelfare'},
        {codeName:'保单查询接口', codeValue:'downPolicy'},
        {codeName:'退款状态接口', codeValue:'refundMoney'},
        {codeName:'纸质保单申请', codeValue:'paperPolicy'},
        {codeName:'快递单号通知', codeValue:'paperPolicyNotice'},
        {codeName:'理赔确认通知', codeValue:'claimNotice'},
        {codeName:"再保承保",codeValue:"1001"},
        {codeName:"再保批改",codeValue:"1002"},
        {codeName:"收付承保",codeValue:"1003"},
        {codeName:"收付批改",codeValue:"1004"},
        {codeName:"销管承保",codeValue:"1005"},
        {codeName:"销管批改",codeValue:"1006"},
        {codeName:"打印承保",codeValue:"1007"},
        {codeName:"打印批改",codeValue:"1008"},
        {codeName:'退款通知', codeValue:'refundMoneyNotice'},
        {codeName:'纸质保单状态主动查询', codeValue:'paperPolicyQuery'},
        {codeName:'长险续费数据同步接口', codeValue:'renewPayTransfer'},
        {codeName:'水滴日账单同步接口', codeValue:'dailyBillTransfer'},
    ]
};
export default Table;